import React from 'react';
import { Stack, styled } from '@mui/material';

import { Icon } from 'ui';

const BulletPoint = ({ children, gap = 0, ...rest }) => (
  <StyledBulletPoint direction='row' gap={gap} alignItems='center' {...rest}>
    <Icon sx={{ alignSelf: 'flex-start' }} name='ChevronRight' color='secondary.main' />
    {children}
  </StyledBulletPoint>
);

export default BulletPoint;

const StyledBulletPoint = styled(Stack)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));
